import { getCookie } from "cookies-next";
import { API } from "../api/types";

export const getInitRoute = (): API.InitRoute => {
  let initPage: string = getCookie("initPage")?.toString() ?? "";
  let id: string = getCookie("id")?.toString() ?? "";
  if (initPage && id && initPage === "po_health/result") {
    return {
      initPage: "Result",
      id: Number(id),
    };
  }
  return {
    initPage: "HealthCheck",
    id: undefined,
  };
};
